import React from 'react';
import CreditCardBrandIcon from '../credit_card_brand_icon';
import CheckoutVerifyCardCVV from '../checkout_verify_card_cvv';
import { core_apimessages_CreditCard } from '../../schemas/rql';

interface IProps {
  creditCard: core_apimessages_CreditCard;
  onSelectCard: React.ChangeEventHandler<HTMLInputElement>;
  isSelected: boolean;
}

function CreditCardOption({ creditCard, onSelectCard, isSelected }: IProps) {
  return (
    <div className="mb-2">
      <label htmlFor={`credit_card_${creditCard.id}`}>
        <div className="d-flex fx-align-start">
          <input
            type="radio"
            id={`credit_card_${creditCard.id}`}
            name="credit_card_id"
            value={creditCard.id}
            onChange={onSelectCard}
            checked={isSelected}
          />
          <div>
            <div className="d-flex fx-align-start">
              <div style={{ width: '5rem' }} className="pl-space">
                <CreditCardBrandIcon brand={creditCard.brand} />
              </div>
              <div className="pl-1 weight-normal">
                <div>{creditCard.display.summary}</div>
                <div className="size-80">{creditCard.display.expirationDate}</div>
              </div>
            </div>
            {(isSelected && creditCard.needsReverification) && (
              <div className="pt-1">
                <CheckoutVerifyCardCVV creditCard={creditCard} />
              </div>
            )}
          </div>
        </div>
      </label>
    </div>
  );
}

export default CreditCardOption;
